// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataTable_wrapper__2yuQy","tableContainer":"DataTable_tableContainer__HyvE6","table":"DataTable_table__33nol","paginationWrapper":"DataTable_paginationWrapper__37DAL"};